import React from 'react'
import Helmet from 'react-helmet'
import { shape, string } from 'prop-types'

const MetaTags = ({ pageContent: data }) => (
  <Helmet>
    <title>{data.title}</title>
    <meta name="description" content={data.metaDescription} />
    <meta property="og:title" content={data.title} />
    <meta property="og:type" content="website" />
    <meta property="og:url" content={window.location.href} />
    <meta property="og:site_name" content="www.asda.com" />
    <meta property="og:description" content={data.metaDescription} />
  </Helmet>
)

MetaTags.propTypes = {
  pageContent: shape({
    metaDescription: string,
    title: string,
  }),
}

MetaTags.defaultProps = {
  pageContent: {
    metaDescription: '',
    title: 'Asda.com',
  },
}

export default MetaTags



// WEBPACK FOOTER //
// ./components/cms/MetaTags.js